import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppPartnerSelectionPopupPage } from './app-partner-selection-popup';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppPartnerSelectionPopupPage,
  ],
    imports: [
        IonicPageModule.forChild(AppPartnerSelectionPopupPage),
        PipesModule,
        DirectivesModule,

    ],
})
export class AppPartnerSelectionPopupPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-partner-selection-popup/app-partner-selection-popup.module.ts